/**
 * @desc 创建子库转移调拨单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationMasterCreateForTransferRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/createTransferOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
